type Environment = {
  RUNTIME_CONFIG_PATH: string;
};

export const BUILD_TIME_ENVIRONMENT: Environment = {
  RUNTIME_CONFIG_PATH: import.meta.env.VITE_RUNTIME_CONFIG_PATH,
};
